<template>
  <page-title pageTitle="Supplier" title="New Supplier" />
  <distributor-form :distributor="{}" :submitFunction="addDistributor" />
</template>

<script>
import PageTitleComponent from "@/components/shared/PageTitle";
import DistributorForm from "@/components/distributor/DistributorForm";

export default {
  name: "NewDistributorView",
  components: {
    PageTitle: PageTitleComponent,
    DistributorForm: DistributorForm,
  },
  data() {
    return {
      id: -1,
      distributor: null,
    };
  },
  methods: {
    async addDistributor(distributor) {
      await this.$store.dispatch("addDistributor", distributor);
      this.$router.push("/distributors");
    },
  },
};
</script>

<style scoped></style>
